import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
  }

  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.addToCartButtonContainer = this.querySelector('[data-ref="add-to-cart-button-container"]');
    this.addToCartButton = this.querySelector('[data-ref="add-to-cart-button"]');
    this.stickyBehavior = this.addToCartButtonContainer.dataset.stickyBehavior || 'add_to_cart';

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  #displayStickyAddToCart() {
    if (isElementInViewport(this.form) || isElementInViewport(this.footer)) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    } else {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    }
  }

  scrollToProduct() {
    window.scrollTo({
      top: this.section.offsetTop,
      behavior: 'smooth',
    });   
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
